import { gql } from '@apollo/client';

export const ADMIN_SET_TRENDING_PRIORITY_MUTATION = gql`
  mutation AdminSetTrendingPriority($postId: ID!, $priority: CommunityPostTrendingPriority, $reason: String) {
    adminSetCommunityPostTrendingPriority(postId: $postId, priority: $priority, reason: $reason) {
      id
      trendingPriority
    }
  }
`;

export const ADMIN_SET_ANNOUNCEMENT_MUTATION = gql`
  mutation AdminSetCommunityPostAnnouncement($postId: ID!, $isAnnouncement: Boolean!) {
    adminSetCommunityPostAnnouncement(postId: $postId, isAnnouncement: $isAnnouncement) {
      id
      isAnnouncement
    }
  }
`;

export const ADMIN_DELETE_COMMUNITY_POST_MUTATION = gql`
  mutation AdminDeleteCommunityPost($postId: ID!) {
    adminDeleteCommunityPost(postId: $postId)
  }
`;
